import { defineStore } from 'pinia';
import { getRequest } from 'helper/request';
import { setURLParam, removeAllURLParams } from 'helper/url';

// eslint-disable-next-line import/prefer-default-export
export const useSupportStore = defineStore('support', {
  state: () => ({
    selectedTopic: null,
    selectedIssueName: null,
    issues: [],
    userOrders: [],
    userProjects: [],
    userOrganizations: [],
    userPhone: null,
    isContactMissing: false,
    areIssuesLoaded: false,
    success: null,
  }),

  getters: {
    isTopicSelected: (state) => !!(state.selectedTopic),
    isIssueSelected: (state) => !!(state.selectedIssueName),
    selectedIssue: (state) => state.issues.find((tempIssue) => tempIssue.name === state.selectedIssueName),
    currentTopicIssues: (state) => {
      if (state.selectedTopic) {
        return state.issues.filter((issue) => issue.topic === state.selectedTopic);
      }
      return state.issues;
    },
  },

  actions: {
    // Initialize store with API data
    initialize(data) {
      this.issues = data.issues;
      this.userOrders = data.orders;
      this.userProjects = data.projects;
      this.userOrganizations = data.organizations;
      this.userPhone = data.user.phone;
      this.isContactMissing = data.user.isContactMissing;
      this.areIssuesLoaded = true;
    },

    // Reset selections and clear URL params
    resetSelections() {
      this.selectedTopic = null;
      this.selectedIssueName = null;
      if (window.location.search !== '') {
        removeAllURLParams();
      }
    },

    // Select topic with validation and URL sync
    selectTopic(topicName) {
      // check if topic is present in our support list
      const topicIssue = this.issues.find((issue) => issue.topic === topicName);
      if (topicIssue) {
        this.selectedTopic = topicName;
        setURLParam('topic', topicName);
      } else {
        this.resetSelections();
      }
    },

    // Select issue with validation and URL sync
    selectIssue(issueName) {
      const newIssue = this.issues.find((issue) => issue.name === issueName);
      // check if issue is present in our support list
      if (newIssue) {
        this.selectedIssueName = newIssue.name;
        setURLParam('issue', newIssue.name);
        this.selectedTopic = newIssue.topic;
        setURLParam('topic', newIssue.topic);
      } else {
        this.resetSelections();
      }
    },

    // Fetch issues and restore URL state
    async fetchIssues(path) {
      const data = await getRequest(path);
      this.initialize(data);
    },
  },
});
